export default {
  direct: 'Directo',
  stops: 'escales',
  stop: 'escala',
}
